import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import pathfinder from '@fiverr-private/pathfinder';

const GO_BACK_TO_FIVERR_URL_COOKIE = 'go_back_to_fiverr_url';

export const useBackToFiverrUrl = () => {
    const [backToFiverrUrl, setBackToFiverrUrl] = useState(pathfinder('root'));

    useEffect(() => {
        const cookies = new Cookies();
        const urlFromCookie = cookies.get(GO_BACK_TO_FIVERR_URL_COOKIE);

        if (typeof urlFromCookie === 'string' && urlFromCookie.length > 0) {
            setBackToFiverrUrl(urlFromCookie);
        }
    }, []);

    return backToFiverrUrl;
};
